import React, { useMemo } from "react";
import Input from "./Input";
import { MilSecToHour, HourToMilSec } from "../../Helpers/MiscHelper";

const HourInput = ({ value, name, onChange, ...rest }) => {
  const handleChange = !onChange
    ? undefined
    : e => {
        const newValue = e.target.value ? HourToMilSec(e.target.value) : "";
        if (isNaN(newValue)) return;
        onChange(newValue);
      };

  const resolvedValue = useMemo(() => {
    if (!value) return value;
    return MilSecToHour(value, true);
  }, [value]);

  return (
    <Input
      name={name}
      value={resolvedValue}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default HourInput;
